<template>
  <div class="mt-2" v-if="statisticsItems.length > 1">
    <v-subheader class="subheading ">Fakta om dette temaet</v-subheader>
    <v-data-table
      hide-headers
      hide-actions
      :pagination.sync="pagination"
      :headers="statisticsHeaders"
      :items="statisticsItems"
    >
      <template v-slot:items="props">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.value }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
export default {
  name: "LayerStatisticsTable",
  props: {
    profile: Object
  },
  watch: {
    profile: function() {
      this.statisticsItems = [];
      this.getAndShowStatistics();
    }
  },
  data: () => ({
    pagination: {
      rowsPerPage: 200
    },
    statisticsHeaders: [
      { text: "Navn", value: "name" },
      { text: "Verdi", value: "value" }
    ],
    statisticsItems: []
  }),
  mounted: function() {
    if (this.profile.hasOwnProperty("serviceUrl")) {
      this.getAndShowStatistics();
    }
  },
  methods: {
    getQueryUrl: function() {
      let url = process.env.VUE_APP_STATISTICS_SERVICE_URL;
      let serviceUrlParts = this.profile.serviceUrl.split("/");
      let mapServiceName = serviceUrlParts[serviceUrlParts.length - 2];
      let queryString = "where=tema ='" + mapServiceName + "'";

      if (this.profile.AddedProfiles) {
        this.profile.AddedProfiles.forEach(addedProfileId => {
          let layer = this.$theMapObject.findLayerById(addedProfileId);

          if (layer) {
            let layerUrlParts = layer.url.split("/");
            let layerServiceName = layerUrlParts[layerUrlParts.length - 2];

            queryString = queryString.concat(
              " OR tema='" + layerServiceName + "'"
            );
          }
        });
      }

      queryString = queryString.concat(
        "&outFields=fakta,verdi&orderByFields=tema&f=pjson&_=" +
          new Date().getTime()
      );

      return encodeURI(url + queryString);
    },
    getAndShowStatistics: function() {
      let url = this.getQueryUrl();
      loadModules(["esri/request"]).then(([esriRequest]) => {
        let shortUrlRequest = esriRequest(url, {
          format: "json"
        });
        shortUrlRequest.then(response => {
          response.data.features.forEach(feature => {
            this.statisticsItems.push({
              name: feature.attributes.fakta,
              value: feature.attributes.verdi
            });
          });
        }),
          function(error) {
            console.error(error);
          };
      });
    }
  }
};
</script>

<style></style>
